import type { KalturaLiveAsset } from '@kaltura-ott/ott-client-types';
import { assetToLinear } from '@kaltura-ott/tvpil';
import { observable } from 'mobx';
import { singleton } from 'tsyringe';

import { fetchChannelsQuery } from '../../rhino/data/channel/fetchChannelsQuery';
import { fetchEntitledChannelsQuery } from '../../rhino/data/channel/fetchEntitledChannelsQuery';
import { Linear } from '../entities/Linear';

@singleton()
export class LinearRepository {
  @observable public linears: Map<number, Linear> = new Map();

  public async init(linearAssetType: string) {
    const [entitledChannels, channelQuery] = await Promise.all([fetchEntitledChannelsQuery(), fetchChannelsQuery()]);

    const channels = channelQuery.objects;

    for (let i = 0; i < channels.length; i++) {
      const assetType = assetToLinear(channels[i] as unknown as KalturaLiveAsset);

      if (!assetType) {
        return;
      }

      const linear = new Linear(assetType);

      linear.linearEntitlement = entitledChannels.has(linear.id);

      this.linears.set(linear.id, linear);
    }
  }

  public getLinearById(id: number): Linear | undefined {
    return this.linears.get(id);
  }

  public isLinear(linear: Linear | undefined): linear is Linear {
    return Boolean(linear && linear.channelNumber && (linear.isPurchased || linear.data.representPackage));
  }
}
